module.exports = __webpack_public_path__ + "img/dh-blue.01a1b200.svg";